



















import { Component, Vue, Prop } from "vue-property-decorator";
import { ProductItem } from "../../common/interfaces";
import Store from "@/store/store";
import axios from "axios";
import { ActionNames } from "@/store/actions";

@Component({})
export default class PartItem extends Vue {
  @Prop() protected part: ProductItem;
  protected quantity: number = 1;
  protected addingPart: boolean = false;

  public incrementQuantity() {
    this.quantity += 1;
  }

  public decrementQuantity() {
    if (!(this.quantity - 1 <= 0)) {
      this.quantity -= 1;
    }
  }

  get partPrice() {
    const sellPrice = this.part.SellingPrice || 0;
    const sellDecimals = this.part.SellDecimals || 2;

    return (sellPrice / Math.pow(10, sellDecimals)).toFixed(sellDecimals);
  }

  public async addPart() {
    this.addingPart = true;
    
    if (Store.state.Job.PartsDetail) {
      try {
        await Store.dispatch(ActionNames.AddPartToQuote, {
          product: this.part,
          quantity: this.quantity
        });
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: err.message,
          offset: 48
        });
      }
    }
    this.addingPart = false;
  }
}
